module.exports = __webpack_public_path__ + "static/media/icon_product_others.673d4c57.svg";